<template>
  
  <!-- Banner Area v-show="isError"-->
  <Banner />
  <div class="flight_Search_boxed" style="text-align: center;" v-show="isError">An error occured accessing car rentals with your account, customer service has been notified and will correct your issue shortly.</div>

 <Loader :active="loaderActive" />
  <!-- Top Service And Tour Area-->
  <TopService />
   <About />

  <!-- Find travel partner -->
  <FindTravellPartner />

  <!--Client Area -->
  <ClientSays />

  <!-- Our partners Area -->
  <Partners />

  <!-- Invisible iframe once loginUrl is available
  <iframe v-if="loginUrl && !loginComplete"
          ref="loginIframe"
          :src="loginUrl"
          style="display:none"
          @load="onIframeLoad">
  </iframe> -->
</template>
<script>
  import Banner from '@/components/home/BannerCars.vue'
  import TopService from '@/components/hometwo/TopService.vue'
  import About from '@/components/hometwo/About.vue'
  import FindTravellPartner from '@/components/hometwo/FindTravellPartner.vue'
  import ClientSays from '@/components/hometwo/ClientSays.vue'
  import Partners from '@/components/home/Partners.vue'
  import store from '@/store'
  import Loader from '@/components/Loader.vue'
  
  

export default {
  name: "RedirectView",
  components: {
    Banner, Partners, TopService, About, FindTravellPartner,ClientSays,Loader
  },
  data() {
    return {
      timeExpire : store.getters.alnSSOTimeExpire,
      username : store.getters.username, 
      isError : false,
    //  loginComplete : false,
      redirect : 'https://car.flystaygo.com/cars/rentals/',
      loginUrl : null,
      loaderActive: false
    }
  },
  watch: {
    '$store.getters.username' : function() {
      this.username = store.getters.username
      this.fetch()
    }
  },
  methods: {
   /* onIframeLoad() {
      if (!this.loginComplete) {
        console.log("WITHIN THE CONST IFRAMELOAD")
        console.log(this.loginUrl)
        this.loginComplete = true
        // Now redirect the main window
        // window.location.href = this.redirect
      }
    },*/
    fetch() {
      var curTime = Date.now()
      if (curTime > 4294967295) curTime = Math.floor(curTime / 1000)
      
      var str = this.$route.path.substring(0,4)
      console.log("START TRY --- " + this.timeExpire +" --- " + curTime +" --- " + this.username)
      // /*
      if (str == '/car' && this.username !== null)
      {
        this.loaderActive = true
        if (curTime > this.timeExpire)
        {
          console.log("START TRY")
          this.$urlRequest.post('accounts', 'carCheck')
           .then((response) => {
          
             //  try {
             //   var response = await this.$urlRequest.post('accounts', 'carCheck') 
      
         
             var loginRedirect = response.redirect //+ "&redirect_uri=" + this.redirect
             //var loginRedirect = "https://jvgames.com"

             console.log("CAR LOGIN")
             //console.log(response)

             if (loginRedirect !== null && loginRedirect != '')
             {
               var parts = loginRedirect.split("&token=");
               
               store.dispatch('UPDATE_USER', {
                 alnSSOTimeExpire : (curTime + 3580),
                 isTransfer2Car : parts[1]
               })
               this.$urlRequest.cookies()

            
               this.loginUrl = loginRedirect
               console.log(this.loginUrl)
               this.loaderActive = true
               window.location.href = this.loginUrl
             }
             else
             {
               this.loaderActive = false
               this.isError = true
             }
           })
          .catch((error) => {
            console.log("Not logged in or error fetching token")
            console.log(error)
            this.loaderActive = false
          })
        }
        else
        {
          this.loaderActive = true
          window.location.href = this.redirect
        } 
      }

        
      // */
    
    },
  },
  mounted () {  // "https://car.flystaygo.com"
   
    this.fetch();
    }
}
</script>
